import React from 'react';
import { Provider } from 'react-redux';

import Base from './Base.jsx';

import UpdatedPopover from '../Components/UpdatedPopover/index.jsx';

import Store from '../Store/index.js';


class EntryPoint extends Base {
  id() {
    return 'cs-asset-updated';
  }

  renderElement(element) {
    var timestamp = element.dataset.timestamp;
    if (timestamp) {
      timestamp = parseInt(timestamp);
      if (isNaN(timestamp)) {
        timestamp = undefined;
      }
    }

    return (
      <Provider store={Store}>
        <UpdatedPopover timestamp={timestamp} />
      </Provider>
    );
  }
}


export default EntryPoint;

